<template>
<v-select :loading="loading" :value="value" :items="items" item-text="title" item-value="value" label="محدوده گزارش" v-bind="$attrs" v-on="$listeners" :rules="requiredRules" @input="v => $emit('input', v)" @change="v => $emit('input', v)">
</v-select>
</template>

<script>
//
export default {
  name: 'MyReportRange',
  props: {
    value: {
      // type: String,
      required: true,
    },
    route: {},
  },
  data() {
    return {
      loading: false,
      items: [],
      requiredRules: [
        v => !!v || 'فیلد اجباری',
      ],
    }
  },
  methods: {
    async retrieveData() {
      //
      this.loading = true
      try {
        this.items = [{
          value: 'today',
          title: 'امروز'
        }, {
          value: 'yesterday',
          title: 'دیروز'
        }, {
          value: 'currentWeek',
          title: 'هفته جاری'
        }, {
          value: 'weekAgo',
          title: 'هفته گذشته'
        }, {
          value: 'dateRange',
          title: 'محدوده تاریخ'
        }, {
          value: 'all',
          title: 'همه'
        }]
        //
        this.loading = false
      } catch (e) {
        console.error(e)
      }
    },
  },
  async created() {
    await this.retrieveData()
  },
}
</script>
